import * as React from "react";
import { useMemo } from "react";
import { Trans, useTranslation } from "react-i18next";
import useFieldTypes from "data-lake/hooks/useFieldTypes";
import { Spinner } from "components/common";
import { Alert } from "components/bootstrap";
import { DocumentationLink } from "components/support";
import DocsHelper from "util/DocsHelper";
import useSelectedDataLake from "data-lake/hooks/useSelectedDataLake";
import { DEFAULT_FIELDS } from "data-lake/preview/storage-types/external/Constants";
import PreviewLayoutContext from "../../../contexts/PreviewLayoutContext";
const FieldSelectInfo = ({ isLoadingFields, tableId = void 0 }) => {
  const { t } = useTranslation("enterprise_data_lake");
  if (isLoadingFields) {
    return /* @__PURE__ */ React.createElement(Spinner, { text: t("external_layout.loading_fields") });
  }
  if (!tableId) {
    return /* @__PURE__ */ React.createElement(Alert, { bsStyle: "warning" }, /* @__PURE__ */ React.createElement(Trans, { t, i18nKey: "external_layout.select_table", components: { bold: /* @__PURE__ */ React.createElement("b", null) } }));
  }
  return null;
};
const WidgetEditInfo = () => {
  const { t } = useTranslation("enterprise_data_lake");
  return /* @__PURE__ */ React.createElement(Alert, null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "external_layout.widget_edit_info",
      components: {
        docsLink: /* @__PURE__ */ React.createElement(DocumentationLink, { page: DocsHelper.PAGES.DATA_LAKE, text: t("external_layout.documentation") })
      }
    }
  ));
};
const PreviewLayoutProvider = ({ children }) => {
  const { isLoading: isLoadingFields } = useFieldTypes();
  const { dataLakeFieldsFetchQuery } = useSelectedDataLake();
  const contextValue = useMemo(
    () => ({
      widgetEdit: {
        fieldSelectInfo: /* @__PURE__ */ React.createElement(FieldSelectInfo, { isLoadingFields, tableId: dataLakeFieldsFetchQuery == null ? void 0 : dataLakeFieldsFetchQuery.tableId }),
        formInfo: /* @__PURE__ */ React.createElement(WidgetEditInfo, null),
        showFieldSelect: !isLoadingFields && !!(dataLakeFieldsFetchQuery == null ? void 0 : dataLakeFieldsFetchQuery.tableId),
        fieldsCreationAllowed: false
      },
      defaultFields: DEFAULT_FIELDS,
      timestampField: "time_dt"
    }),
    [dataLakeFieldsFetchQuery == null ? void 0 : dataLakeFieldsFetchQuery.tableId, isLoadingFields]
  );
  return /* @__PURE__ */ React.createElement(PreviewLayoutContext.Provider, { value: contextValue }, children);
};
export default PreviewLayoutProvider;
